const ja = {
  // Navigation
  nav_home: "\u30db\u30fc\u30e0",
  nav_explore: "\u63a2\u7d22",
  nav_workspace: "ワークスペース",
  ws_videos: "ビデオ",
  ws_untitled: "無題のビデオ",
  // A generation that failed. The card carries these until it is dismissed.
  ws_failed_title: "ビデオが失敗しました",
  ws_failed_refunded: "クレジットが返されました",
  ws_failed_dismiss: "却下する",
  ws_failed_retry: "もう一度やり直してください",
  ws_failed_retrying: "起動…",
  ws_failed_banner_one: "ビデオの生成に失敗しました",
  ws_failed_banner_many: "{n} 本の動画が失敗しました",
  ws_failed_banner_body: "何も請求されませんでした。クレジットはアカウントに返金されました。もう一度試すか、別のトピックを選択してください。",
  ws_empty_title: "ここにはまだ何もありません。",
  ws_empty_body: "作成したすべてのビデオが最新のものから順にここに表示されます。",
  ws_generate: "生成する",
  ws_composer_placeholder: "レッスンについて説明します\u2026",
  ws_placeholder_hw: "割り当てに名前を付けます… (オプション)",
  ws_placeholder_lecture: "講義に名前を付けます… (オプション)",
  ws_placeholder_self_study: "何を勉強したいのですか？",
  nav_search: "\u52d5\u753b\u3092\u691c\u7d22...",
  nav_search_yours: "動画を検索...",
  nav_notifications: "\u901a\u77e5",
  nav_mark_all_read: "\u3059\u3079\u3066\u65e2\u8aad\u306b\u3059\u308b",
  nav_no_notifications: "\u307e\u3060\u901a\u77e5\u306f\u3042\u308a\u307e\u305b\u3093",
  nav_no_notifications_sub: "\u52d5\u753b\u304c\u6e96\u5099\u3067\u304d\u305f\u3089\u304a\u77e5\u3089\u305b\u3057\u307e\u3059",
  nav_upgrade: "\u30a2\u30c3\u30d7\u30b0\u30ec\u30fc\u30c9",
  nav_billing: "\u8acb\u6c42",
  nav_settings: "\u8a2d\u5b9a",
  nav_contact: "\u304a\u554f\u3044\u5408\u308f\u305b",
  nav_api: "API",
  nav_sign_out: "\u30b5\u30a4\u30f3\u30a2\u30a6\u30c8",
  nav_just_now: "\u305f\u3063\u305f\u4eca",
  nav_minutes_ago: "{n}\u5206\u524d",
  nav_hours_ago: "{n}\u6642\u9593\u524d",
  nav_days_ago: "{n}\u65e5\u524d",
  nav_used_this_month: "\u4eca\u6708 {used} \u4e2d {cap} \u4f7f\u7528\u6e08\u307f",
  // locale file, and this one is the obvious thing to reach for if a weekly bucket returns.
  nav_used_today: "今週使用された {used} 個中 {limit} 個",
  nav_free_daily: "週に 4 本の無料動画",
  // Settings
  settings_title: "\u8a2d\u5b9a",
  settings_profile: "\u30d7\u30ed\u30d5\u30a3\u30fc\u30eb",
  settings_change_avatar: "\u30a2\u30d0\u30bf\u30fc\u3092\u5909\u66f4",
  settings_cancel: "\u30ad\u30e3\u30f3\u30bb\u30eb",
  settings_choose_wizard: "\u9b54\u6cd5\u4f7f\u3044\u3092\u9078\u3093\u3067\u304f\u3060\u3055\u3044",
  settings_display_name: "\u8868\u793a\u540d",
  settings_your_name: "\u3042\u306a\u305f\u306e\u540d\u524d",
  settings_save: "\u4fdd\u5b58",
  settings_saving: "\u4fdd\u5b58\u4e2d...",
  settings_saved: "\u4fdd\u5b58\u3057\u307e\u3057\u305f",
  settings_save_failed: "\u4fdd\u5b58\u306b\u5931\u6557\u3057\u307e\u3057\u305f",
  settings_email: "\u30e1\u30fc\u30eb",
  settings_notifications: "\u901a\u77e5",
  settings_email_notif: "\u30e1\u30fc\u30eb\u901a\u77e5",
  settings_email_notif_desc: "\u30e1\u30fc\u30eb\u3067\u66f4\u65b0\u3068\u304a\u77e5\u3089\u305b\u3092\u53d7\u3051\u53d6\u308b",
  settings_language: "\u8a00\u8a9e",
  settings_language_desc: "\u30a2\u30d7\u30ea\u3068\u52d5\u753b\u30ca\u30ec\u30fc\u30b7\u30e7\u30f3\u306e\u8a00\u8a9e\u3092\u9078\u629e",
  settings_data_title: "あなたのデータ",
  settings_data_desc: "プロフィール、ビデオ、コース、セッション、サポート メッセージなど、アカウントに関連付けられた個人データのコピーをダウンロードします。内部システムログと派生処理データは含まれません。",
  settings_data_download: "データをダウンロードする",
  settings_data_exporting: "準備中…",
  settings_danger: "\u5371\u967a\u30be\u30fc\u30f3",
  settings_delete_account: "\u30a2\u30ab\u30a6\u30f3\u30c8\u3092\u524a\u9664",
  settings_delete_desc: "\u30a2\u30ab\u30a6\u30f3\u30c8\u3068\u3059\u3079\u3066\u306e\u95a2\u9023\u30c7\u30fc\u30bf\u3092\u5b8c\u5168\u306b\u524a\u9664\u3057\u307e\u3059\u3002\u3053\u306e\u64cd\u4f5c\u306f\u53d6\u308a\u6d88\u305b\u307e\u305b\u3093\u3002",
  settings_delete_confirm: "\u30a2\u30ab\u30a6\u30f3\u30c8\u3068\u3059\u3079\u3066\u306e\u30c7\u30fc\u30bf\u304c\u5b8c\u5168\u306b\u524a\u9664\u3055\u308c\u307e\u3059\u3002\u78ba\u8a8d\u306e\u305f\u3081 {keyword} \u3068\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044\u3002",
  settings_delete_placeholder: "\u78ba\u8a8d\u306e\u305f\u3081 \"DELETE\" \u3068\u5165\u529b",
  settings_permanently_delete: "\u5b8c\u5168\u306b\u524a\u9664",
  settings_deleting: "\u524a\u9664\u4e2d...",
  explore_watch_now: "\u4eca\u3059\u3050\u898b\u308b",
  // One pair of strings per scene; the eyebrow and the button are shared.
  explore_no_preview: "\u30d7\u30ec\u30d3\u30e5\u30fc\u306a\u3057",
  explore_no_videos: "\u307e\u3060\u52d5\u753b\u306f\u3042\u308a\u307e\u305b\u3093\u3002\u307e\u305f\u5f8c\u3067\u78ba\u8a8d\u3057\u3066\u304f\u3060\u3055\u3044\uff01",
  explore_featured_courses: "注目のコース",
  course_lesson_count: "{n, plural, one {# lesson} other {# lessons}}",
  course_back_to_explore: "探索に戻る",
  course_not_found: "このコースはご利用いただけません。",
  // Home Page
  home_hero: "\u4f55\u3067\u3082\u5b66\u3079\u308b\u3001",
  home_hero_accent: "\u30d3\u30b8\u30e5\u30a2\u30eb\u306b",
  home_placeholder: "\u4f55\u3092\u5b66\u3073\u305f\u3044\u3067\u3059\u304b\uff1f",
  home_extracting: "\u554f\u984c\u3092\u62bd\u51fa\u4e2d...",
  home_videos_generated: "{n, plural, other {#\u672c\u306e\u52d5\u753b}}\u304c\u751f\u6210\u3055\u308c\u307e\u3059",
  home_credits: "{n, plural, other {#\u30af\u30ec\u30b8\u30c3\u30c8}}",
  home_remaining: "\u4eca\u6708\u306e\u6b8b\u308a",
  home_enter_prompt: "\u5b66\u3073\u305f\u3044\u3053\u3068\u307e\u305f\u306f\u89e3\u304d\u305f\u3044\u3053\u3068\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044",
  home_popular: "\u4eba\u6c17\u306e\u30ec\u30c3\u30b9\u30f3",
  home_from_community: "\u30b3\u30df\u30e5\u30cb\u30c6\u30a3\u304b\u3089",
  home_community_sub: "\u5b66\u751f\u305f\u3061\u306e\u4f5c\u54c1\u3092\u898b\u308b",
  home_tips_label: "マギの魔法使いより",
  home_tips_title: "ヒントとコツ",
  home_tip1_title: "具体的にする",
  home_tip1_desc: "件名全体を入力しないでください。アイデア、コンセプト、質問を 1 つずつ選択してください。",
  home_tip1_example: "真核細胞における DNA 複製の仕組み",
  home_tip2_title: "誰のためのものかを言ってください",
  home_tip2_desc: "中学校の説明と大学の講義は全く違います。",
  home_tip2_example: "代数を学んだばかりの人向けに導関数を説明する",
  home_tip3_title: "マギに欲しいものを伝えてください",
  home_tip3_desc: "例、ステップバイステップの現実世界のアプリケーション - 言うだけで、Magi がフォローします。",
  home_tip3_example: "水循環の実例と概要",
  home_tip_try: "次のようなことを試してください",
  home_proven_social: "Instagramでフォローしてください",
  home_ig_desc_1: "",
  home_ig_followers: "55,000\u4eba\u306e\u30d5\u30a9\u30ed\u30ef\u30fc",
  home_ig_desc_2: "Instagram で数学と科学のビデオを毎日ご覧ください。これらのリールは、ここで使用しているものと同じエンジンで作られています。",
  home_view_profile: "\u30d7\u30ed\u30d5\u30a3\u30fc\u30eb\u3092\u898b\u308b",
  home_subscribe_now: "\u4eca\u3059\u3050\u767b\u9332",
  home_sub_monthly: "\u6708\u984d",
  home_sub_yearly: "\u5e74\u984d",
  // goes false the moment either price moves, on the surface where that matters most.
  home_sub_yearly_save: "{pct}% を節約",
  home_sub_per_month: "/ \u6708",
  home_sub_billed_monthly: "毎月 ${amount} が請求されます",
  home_sub_processing: "\u51e6\u7406\u4e2d...",
  home_sub_no_commitment: "\u7e1b\u308a\u306a\u3057\u3002\u3044\u3064\u3067\u3082\u89e3\u7d04\u53ef\u80fd\u3002",
  home_sub_secured: "Stripe\u3067\u4fdd\u8b77",
  home_sub_headline: "{plan} でさらにロックを解除しましょう",
  home_sub_due_now: "今すぐ期限",
  home_sub_trial_label: "{days} 日間のフルアクセス",
  // choosing the plan directly is owed exactly what a trialist is owed.
  home_sub_monthly_terms: "今月 ${amount} 本の動画に対して、本日 {n} が請求されます。最初にキャンセルしない限り、{date} に ${amount}/月で更新されます。[請求] からいつでもキャンセルできます。",
  // frequency, states that it happens automatically, and says where to cancel.
  home_sub_trial_terms: "本日、${trial} 日間のフルアクセスに対して {days} が課金されます (動画数は {n} 個に制限されています)。トライアルは ${trial} では続行されません。{date} には、自動的に月額 {planName} の ${plan} になり（{full} 動画）、その後はキャンセルするまで毎月 ${plan} が請求されます。 [請求] からいつでもキャンセルできます。",
  home_sub_card: "クレジットカードまたはデビットカード",
  home_sub_billed_once_yearly: "${amount} を年に 1 回請求",
  home_sub_billed_trial: "${amount} を {days} 日間請求し、その後は毎月 ${renews} で更新されます",
  home_sub_switch_plan: "代わりに {plan} をお探しですか?",
  home_sub_replaces_plan: "{plan} プランを置き換えます。請求日は変わりません。上に移動すると差額が今すぐ請求され、下に移動すると次回の更新から始まります。",
  home_sub_change_now: "{plan}に変更しました。差額として{amount}を請求しました。",
  home_sub_change_later: "{date}に{plan}へ切り替わります。本日の請求はありません。",
  // the allowance changed; this one cannot.
  home_sub_feature_videos_n: "\u6708 {n} \u672c\u306e\u52d5\u753b",
  // Pricing Page
  pricing_title: "\u30d7\u30e9\u30f3\u3092\u30a2\u30c3\u30d7\u30b0\u30ec\u30fc\u30c9",
  pricing_monthly: "\u6708\u984d",
  pricing_yearly: "\u5e74\u984d",
  pricing_save: "17%\u304a\u5f97",
  pricing_best_value: "\u304a\u5f97",
  pricing_your_plan: "\u73fe\u5728\u306e\u30d7\u30e9\u30f3",
  pricing_get_started: "\u59cb\u3081\u308b",
  pricing_processing: "\u51e6\u7406\u4e2d...",
  pricing_per_month: "/\u6708",
  pricing_billed_yearly: "\u5e74\u984d ${amount}",
  pricing_videos_month: "\u6708 {n, plural, other {#\u672c\u306e\u52d5\u753b}}",
  pricing_manage_cancel: "管理またはキャンセル",
  pricing_manage_unavailable: "管理できるサブスクリプションが見つかりませんでした。お問い合わせいただければ対応します。",
  pricing_opening: "\u958b\u3044\u3066\u3044\u307e\u3059...",
  billing_autorenew_monthly: "キャンセルするまで、${amount}/月で自動的に更新されます。",
  billing_autorenew_yearly: "キャンセルするまで、${amount}/年で自動的に更新されます。",
  billing_autorenews_on: "自動更新 {date} · いつでもキャンセル可能",
  pricing_secured: "Stripe\u3067\u4fdd\u8b77",
  pricing_login_required: "\u30b5\u30d6\u30b9\u30af\u30ea\u30d7\u30b7\u30e7\u30f3\u306b\u306f\u30ed\u30b0\u30a4\u30f3\u304c\u5fc5\u8981\u3067\u3059",
  pricing_auth_error: "\u8a8d\u8a3c\u30a8\u30e9\u30fc\u3067\u3059\u3002\u30ed\u30b0\u30a2\u30a6\u30c8\u3057\u3066\u518d\u5ea6\u30ed\u30b0\u30a4\u30f3\u3057\u3066\u304f\u3060\u3055\u3044\u3002",
  pricing_feature_pdf: "PDF\u30fb\u753b\u50cf\u306e\u62bd\u51fa",
  pricing_feature_quality: "\u9ad8\u54c1\u8cea\u30e2\u30c7\u30eb",
  pricing_feature_speed: "\u3088\u308a\u9ad8\u901f\u306a\u751f\u6210",
  pricing_feature_study: "\u5b66\u7fd2\u30bb\u30c3\u30b7\u30e7\u30f3",
  pricing_free_hint: "\u73FE\u5728\u30D5\u30EA\u30FC\u30D7\u30E9\u30F3\u3092\u3054\u5229\u7528\u4E2D",
  // Billing Page
  billing_title: "\u8acb\u6c42",
  billing_current_plan: "\u73fe\u5728\u306e\u30d7\u30e9\u30f3",
  billing_payment_failed_title: "計画は一時停止されています",
  billing_payment_failed_body: "{amount} を回収できなかったため、プランは一時停止されています。カードを更新して再度開始してください。また、再試行を続けます。",
  billing_payment_failed_cta: "支払いを修正",
  billing_change_plan: "\u30d7\u30e9\u30f3\u3092\u5909\u66f4",
  billing_invoices: "\u8acb\u6c42\u66f8",
  billing_loading: "\u8acb\u6c42\u66f8\u3092\u8aad\u307f\u8fbc\u307f\u4e2d...",
  billing_no_invoices: "\u307e\u3060\u8acb\u6c42\u66f8\u306f\u3042\u308a\u307e\u305b\u3093",
  billing_date: "\u65e5\u4ed8",
  billing_amount: "\u91d1\u984d",
  billing_status: "\u30b9\u30c6\u30fc\u30bf\u30b9",
  billing_invoice: "\u8acb\u6c42\u66f8",
  billing_view: "\u8868\u793a",
  // Contact Page
  contact_title: "\u304a\u554f\u3044\u5408\u308f\u305b",
  contact_placeholder: "\u3069\u306e\u3088\u3046\u306b\u304a\u624b\u4f1d\u3044\u3067\u304d\u307e\u3059\u304b\uff1f",
  contact_sent_desc: "\u3067\u304d\u308b\u3060\u3051\u65e9\u304f\u304a\u8fd4\u4e8b\u3057\u307e\u3059\u3002",
  contact_signin: "サポートに連絡するにはサインインしてください。",
  // Generation Queue
  queue_title: "\u30ad\u30e5\u30fc",
  queue_active: "{n} \u30a2\u30af\u30c6\u30a3\u30d6",
  queue_generating: "{n} \u751f\u6210\u4e2d",
  queue_ready: "\u8996\u8074\u6e96\u5099\u5b8c\u4e86",
  queue_in_queue: "順番待ちです...",
  queue_almost_ready: "\u3082\u3046\u3059\u3050...",
  queue_seconds_left: "\u6b8b\u308a{n}\u79d2",
  queue_minutes_left: "\u6b8b\u308a{m}\u5206{s}\u79d2",
  queue_watch_now: "\u4eca\u3059\u3050\u898b\u308b",
  queue_waiting: "\u30ad\u30e5\u30fc\u3067\u5f85\u6a5f\u4e2d...",
  queue_empty: "\u30ad\u30e5\u30fc\u306b\u52d5\u753b\u306f\u3042\u308a\u307e\u305b\u3093",
  queue_empty_sub: "\u52d5\u753b\u3092\u751f\u6210\u3059\u308b\u3068\u3053\u3053\u306b\u8868\u793a\u3055\u308c\u307e\u3059",
  queue_clear: "\u3059\u3079\u3066\u30af\u30ea\u30a2",
  queue_total: "\u5408\u8a08 {n}",
  queue_first_time: "\u52d5\u753b\u3092\u751f\u6210\u4e2d\u3067\u3059",
  queue_first_time_sub: "\u901a\u5e38\u7d042\u5206\u3002\u6e96\u5099\u304c\u3067\u304d\u305f\u3089\u97f3\u3067\u304a\u77e5\u3089\u305b\u3057\u307e\u3059\u3002",
  // Session Expired
  session_expired: "\u30bb\u30c3\u30b7\u30e7\u30f3\u304c\u671f\u9650\u5207\u308c\u3067\u3059",
  session_expired_desc: "\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u4e0a\u306e\u7406\u7531\u3067\u30bb\u30c3\u30b7\u30e7\u30f3\u304c\u671f\u9650\u5207\u308c\u306b\u306a\u308a\u307e\u3057\u305f\u3002\u7d9a\u3051\u308b\u306b\u306f\u518d\u5ea6\u30b5\u30a4\u30f3\u30a4\u30f3\u3057\u3066\u304f\u3060\u3055\u3044\u3002",
  // Cookie Banner
  cookie_text: "\u30b5\u30a4\u30c8\u306e\u30c8\u30e9\u30d5\u30a3\u30c3\u30af\u5206\u6790\u3068\u4f53\u9a13\u5411\u4e0a\u306e\u305f\u3081\u306bCookie\u3092\u4f7f\u7528\u3057\u3066\u3044\u307e\u3059\u3002\u30c7\u30d5\u30a9\u30eb\u30c8\u3067\u306f\u5fc5\u9808Cookie\u306e\u307f\u8a2d\u5b9a\u3055\u308c\u307e\u3059\u3002",
  cookie_learn_more: "\u8a73\u3057\u304f",
  cookie_accept: "\u3059\u3079\u3066\u53d7\u3051\u5165\u308c\u308b",
  cookie_reject: "\u4e0d\u8981\u306aCookie\u3092\u62d2\u5426",
  // Create Project Modal
  create_new_project: "\u65b0\u898f\u30d7\u30ed\u30b8\u30a7\u30af\u30c8",
  create_extracting: "\u62bd\u51fa\u4e2d...",
  create_select_problems: "\u554f\u984c\u3092\u9078\u629e",
  create_select_topics: "\u30c8\u30d4\u30c3\u30af\u3092\u9078\u629e",
  create_new_video: "\u65b0\u898f\u52d5\u753b",
  create_new_hw: "\u65b0\u898f\u5bbf\u984c\u30d7\u30ed\u30b8\u30a7\u30af\u30c8",
  create_new_lecture: "\u65b0\u898f\u8b1b\u7fa9\u30d7\u30ed\u30b8\u30a7\u30af\u30c8",
  create_new_self_study: "新しいプロジェクト",
  create_video: "\u52d5\u753b",
  create_homework: "\u5bbf\u984c",
  create_lecture: "\u8b1b\u7fa9",
  create_self_study: "プロジェクト",
  create_video_sub: "\u52d5\u753b\u3092\u751f\u6210",
  create_hw_sub: "\u5bbf\u984c\u3092\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9",
  create_lecture_sub: "\u30b9\u30e9\u30a4\u30c9\u3092\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9",
  create_self_study_sub: "\u30c8\u30d4\u30c3\u30af\u3092\u9078\u3076",
  create_video_prompt: "\u52d5\u753b\u3067\u4f55\u3092\u8aac\u660e\u3057\u307e\u3059\u304b\uff1f",
  create_project_title: "\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u540d",
  create_video_hint: "\u3053\u308c\u304c\u52d5\u753b\u306e\u30bf\u30a4\u30c8\u30eb\u3068\u30d7\u30ed\u30f3\u30d7\u30c8\u306e\u4e21\u65b9\u306b\u4f7f\u7528\u3055\u308c\u307e\u3059\u3002",
  create_drop_hw: "\u5bbf\u984c\u3092\u3053\u3053\u306b\u30c9\u30ed\u30c3\u30d7",
  create_drop_lecture: "\u30b9\u30e9\u30a4\u30c9\u3092\u3053\u3053\u306b\u30c9\u30ed\u30c3\u30d7",
  create_file_types: "PDF, PNG, JPG, HEIC",
  // Shown over the composer while a file is being dragged onto it.
  composer_drop_hint: "ドロップしてプロジェクトを開始する",
  create_reading_hw: "\u5bbf\u984c\u3092\u8aad\u307f\u53d6\u308a\u4e2d",
  create_reading_lecture: "\u8b1b\u7fa9\u3092\u8aad\u307f\u53d6\u308a\u4e2d",
  create_finding_problems: "\u554f\u984c\u3092\u691c\u51fa\u30fb\u62bd\u51fa\u4e2d...",
  create_finding_topics: "\u30c8\u30d4\u30c3\u30af\u3092\u62bd\u51fa\u4e2d...",
  create_add_video: "\u52d5\u753b\u3092\u8ffd\u52a0",
  create_add_more_files: "\u30d5\u30a1\u30a4\u30eb\u3092\u8ffd\u52a0",
  create_starting: "\u751f\u6210\u3092\u958b\u59cb\u4e2d...",
  create_generate_video: "\u52d5\u753b\u3092\u751f\u6210 \u00B7 1\u30af\u30ec\u30b8\u30c3\u30c8",
  create_generate_n: "{n, plural, other {#\u672c\u306e\u52d5\u753b}}\u3092\u751f\u6210 \u00B7 {n, plural, other {#\u30af\u30ec\u30b8\u30c3\u30c8}}",
  create_create_project: "\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u3092\u4f5c\u6210 \u00B7 {n, plural, other {#\u30af\u30ec\u30b8\u30c3\u30c8}}",
  create_no_problems: "\u554f\u984c\u304c\u898b\u3064\u304b\u308a\u307e\u305b\u3093\u3067\u3057\u305f\u3002\u3088\u308a\u9bae\u660e\u306a\u5199\u771f\u304b\u5225\u306e\u30da\u30fc\u30b8\u3092\u8a66\u3057\u3066\u304f\u3060\u3055\u3044\u3002",
  create_no_topics: "\u30c8\u30d4\u30c3\u30af\u304c\u898b\u3064\u304b\u308a\u307e\u305b\u3093\u3067\u3057\u305f\u3002\u3088\u308a\u9bae\u660e\u306a\u5199\u771f\u304b\u5225\u306e\u30d5\u30a1\u30a4\u30eb\u3092\u8a66\u3057\u3066\u304f\u3060\u3055\u3044\u3002",
  create_error: "\u554f\u984c\u304c\u767a\u751f\u3057\u307e\u3057\u305f\u3002\u3082\u3046\u4e00\u5ea6\u304a\u8a66\u3057\u304f\u3060\u3055\u3044\u3002",
  create_extract_daily_limit: "本日の資料は以上でございます。続きはまた明日。",
  create_video_topic_placeholder: "\u52d5\u753b {n} \u306e\u30c8\u30d4\u30c3\u30af\u3001\u4f8b: \"\u56fa\u6709\u5024\u3068\u56fa\u6709\u30d9\u30af\u30c8\u30eb\"",
  video_share: "\u5171\u6709",
  // and made the two indistinguishable.
  video_followup_placeholder: "フォローアップビデオを生成...",
  video_chip_simpler: "\u3082\u3063\u3068\u7c21\u5358\u306b",
  video_chip_harder: "\u96e3\u3057\u3044\u4f8b",
  video_chip_real_world: "\u5b9f\u4e16\u754c\u3067\u306e\u4f7f\u7528",
  // spends a credit generating a new one.
  video_ask_title: "このビデオについて質問する",
  video_ask_cta: "これについてチャットする",
  video_ask_placeholder: "質問してください...",
  video_ask_thinking: "考え...",
  video_ask_close: "近い",
  video_ask_chip_explain: "その部分を説明してください",
  video_ask_chip_example: "例を挙げてください",
  video_ask_chip_why: "なぜそれが機能するのでしょうか?",
  video_ask_limit_reached: "本日の質問制限に達しました。明日リセットです。",
  video_up_next: "\u6b21\u306e\u52d5\u753b",
  video_no_suggested: "\u304a\u3059\u3059\u3081\u52d5\u753b\u306f\u307e\u3060\u3042\u308a\u307e\u305b\u3093",
  video_untitled: "\u7121\u984c\u306e\u52d5\u753b",
  video_created_recently: "\u6700\u8fd1\u4f5c\u6210",
  video_just_now: "\u305f\u3063\u305f\u4eca",
  video_minutes_ago: "{n, plural, other {#\u5206}}\u524d",
  video_hours_ago: "{n, plural, other {#\u6642\u9593}}\u524d",
  video_days_ago: "{n, plural, other {#\u65e5}}\u524d",
  video_weeks_ago: "{n, plural, other {#\u9031\u9593}}\u524d",
  video_months_ago: "{n, plural, other {#\u304b\u6708}}\u524d",
  video_years_ago: "{n, plural, other {#\u5e74}}\u524d",
  video_unknown_date: "\u4e0d\u660e\u306a\u65e5\u4ed8",
  video_download_error: "\u554f\u984c\u304c\u767a\u751f\u3057\u307e\u3057\u305f\u3002\u3082\u3046\u4e00\u5ea6\u304a\u8a66\u3057\u304f\u3060\u3055\u3044\u3002",
  // Search Results
  search_no_results: "\u7d50\u679c\u304c\u898b\u3064\u304b\u308a\u307e\u305b\u3093",
  search_no_results_for: "\"{query}\" \u306e\u7d50\u679c\u304c\u898b\u3064\u304b\u308a\u307e\u305b\u3093",
  search_all_videos: "\u3059\u3079\u3066\u306e\u52d5\u753b\u3092\u691c\u7d22",
  search_enter_term: "\u691c\u7d22\u8a9e\u3092\u5165\u529b\u3057\u3066\u52d5\u753b\u3092\u898b\u3064\u3051\u3066\u304f\u3060\u3055\u3044",
  search_retry: "\u691c\u7d22\u3092\u3084\u308a\u76f4\u3059",
  auth_continue_google: "Google\u3067\u7d9a\u3051\u308b",
  // sentence, and the box ships unticked — a pre-ticked box is not consent.
  home_sub_waiver: "すぐにアクセスを開始してください。これは、{days} 日間の出金と払い戻しを受ける権利を放棄することを意味することを理解しています。",
  home_sub_waiver_required: "続行するにはこれを確認してください。",
  home_sub_agree_prefix: "続行すると、次のことに同意したことになります",
  // floor is 13 — if that clause changes, this string and DIGITAL_CONSENT_AGE move with it.
  auth_min_age: "Magi を使用するには、{age} 以上である必要があります。",
  auth_agree_prefix: "\u30b5\u30a4\u30f3\u30a4\u30f3\u3059\u308b\u3053\u3068\u3067\u3001",
  auth_terms: "\u5229\u7528\u898f\u7d04",
  auth_and: "\u3068",
  auth_privacy: "\u30d7\u30e9\u30a4\u30d0\u30b7\u30fc\u30dd\u30ea\u30b7\u30fc",
  auth_email_optin: "ヒントや最新情報を送ってください",
  // Auth modal (Google + email/password)
  auth_signin_title: "マギにサインインする",
  auth_signin_desc: "中断したところから再開します。",
  auth_signup_title: "アカウントを作成する",
  auth_signup_desc: "無料で始められ、カードは必要ありません。",
  auth_or: "または",
  auth_continue_email: "メールで続行",
  auth_signing_in: "サインイン中…",
  auth_working: "ちょっと…",
  auth_email_placeholder: "電子メールアドレス",
  auth_password_placeholder: "パスワード",
  auth_signin_submit: "サインイン",
  auth_signup_submit: "アカウントを作成する",
  auth_no_account: "ここは新しいですか？",
  auth_signup_link: "アカウントを作成する",
  auth_have_account: "すでにアカウントをお持ちですか?",
  auth_signin_link: "サインイン",
  auth_forgot_password: "パスワードをお忘れですか？",
  auth_reset_title: "パスワードをリセットする",
  auth_reset_desc: "新しいリンクを設定するためのリンクをメールでお送りします。",
  auth_reset_submit: "リセットリンクを送信する",
  auth_reset_sent: "リセット用のリンクがあるかどうかメールを確認してください。",
  auth_back_to_signin: "サインインに戻る",
  // Full-screen wall shown to a signed-in account that has not confirmed its address.
  verify_wall_title: "続行するにはメールを確認してください",
  verify_wall_desc: "確認リンクを {email} に送信しました。それをクリックして、ここに戻ってください。",
  verify_wall_check: "確認しました",
  verify_wall_checking: "チェック中...",
  verify_wall_still_unverified: "まだ確認されていません。メール内のリンクをクリックして、もう一度試してください。",
  verify_wall_resend: "リンクをもう一度送信してください",
  verify_wall_resent: "送信済み。受信箱とスパムフォルダーを確認してください。",
  verify_wall_wrong_account: "アカウントが間違っていますか?サインアウト",
  // The screen the confirmation LINK lands on, replacing Firebase's unbranded handler page.
  verify_action_working_title: "メールを確認しています",
  verify_action_working_desc: "ちょっと。",
  verify_action_done_title: "準備は完了です",
  verify_action_done_desc: "あなたのメールアドレスが確認されました。Magiへようこそ。",
  verify_action_done_cta: "学習を開始する",
  verify_action_failed_title: "そのリンクは機能しませんでした",
  verify_action_failed_desc: "すでに使用されているか、有効期限が切れている可能性があります。戻って新しいものを自分に送ってください。",
  verify_action_failed_cta: "Magiに戻る",
  // Wall copy — each surface names what signing in actually gets you
  auth_watch_title: "サインインして視聴する",
  auth_watch_desc: "このビデオを再生するには、無料のアカウントを作成してください。",
  auth_watch_ready_title: "ビデオの準備ができました",
  auth_watch_ready_desc: "サインインして視聴してください。アカウントに保存されます。",
  // rather than saying "sign in" twice — the specific ask converts, the generic one nags.
  auth_download_title: "ダウンロードするにはサインインしてください",
  auth_download_desc: "このビデオを保存するには無料のアカウントを作成してください。",
  auth_ask_title: "サインインして質問する",
  auth_ask_desc: "このビデオについて質問するには、無料のアカウントを作成してください。",
  auth_browse_title: "サインインして閲覧する",
  auth_browse_desc: "無料のアカウントを作成して、すべてのレッスンを探索してください。",
  auth_workspace_title: "サインインして自分の作品を確認してください",
  auth_workspace_desc: "レッスンとプロジェクトはアカウント内に保存されます。",
  auth_generate_title: "作成を続けるにはサインインしてください",
  auth_generate_desc: "無料アカウントでは毎日ビデオを入手できます。",
  video_restricted: "このビデオはまだ利用できません。",
  // Share sheet
  share_title: "このビデオを共有する",
  share_desc_mobile: "ストーリーに投稿するか、友達に送信するか、リンクをコピーしてください。",
  share_desc_desktop: "リンクをコピーするか、ビデオをダウンロードして携帯電話から投稿します。",
  share_to_apps: "Instagramなどにシェア",
  share_copy_link: "リンクをコピー",
  share_copied: "リンクがコピーされました",
  share_download: "ビデオをダウンロードする",
  share_preparing: "準備中です…",
  share_watermark_note: "共有ビデオには magiacademy.com が含まれます",
  // Welcome Modal (post-signup)
  welcome_title: "マギへようこそ",
  welcome_subtitle: "まずは 4 本の無料ビデオをご覧ください。",
  welcome_optin_reward: "+1 無料ビデオ",
  welcome_continue: "続く",
  age_gate_continue: "続く",
  age_gate_saving: "保存中...",
  // Landing Page
  landing_hero: "トピックを入力します。",
  landing_hero2: "ビデオレッスンを受けてください。",
  landing_subtitle: "Magi は、あらゆる主題を数分で美しくアニメーション化されたナレーション付きビデオに変換します。撮影も編集も専門知識も必要ありません。",
  landing_signup_google: "Google に登録する",
  landing_signing_in: "\u30b5\u30a4\u30f3\u30a4\u30f3\u4e2d...",
  landing_chat_bubble: "GPS は相対性理論をどのように利用するのでしょうか?",
  landing_stats_title: "世界中の学習者から信頼されています",
  landing_stat_videos: "3,000以上",
  landing_stat_videos_desc: "生成されたビデオ",
  landing_stat_languages_desc: "言語",
  landing_stat_speed: "～1分",
  landing_stat_speed_desc: "生成時間",
  landing_feature_lecture_title: "講義ノートを捨てて、ビデオを入手してください",
  landing_feature_lecture_desc: "スライドまたはメモをアップロードします。 Magi は各トピックを抽出し、それぞれについてビデオ説明を生成します。",
  landing_feature_hw_title: "宿題で行き詰まっていませんか？アップロードしてください。",
  landing_feature_hw_desc: "問題セットをドロップすると、Magi が各問題を抽出し、ステップバイステップのビデオで解決策を説明します。",
  landing_feature_chat_title: "視聴しながら質問する",
  landing_feature_chat_desc: "すべてのビデオには、チャットできる AI 講師が付属しています。フォローアップの質問をしたり、より深い説明を得たり、さらに理解したい特定の部分に関する新しいビデオをリクエストしたりできます。",
  landing_feature_lang_title: "あなたの言語で学びましょう",
  landing_feature_lang_desc: "Magi は、英語、スペイン語、ヒンディー語、中国語、日本語などでビデオを生成します。任意の言語でトピックを入力すると、その言語で完全にナレーション付きのレッスンが表示されます。",
  landing_cta_title: "数秒で学習を開始",
  landing_cta_google: "Google を続ける",
  // Onboarding Bubbles
  onboarding_step1: "\u3053\u308c\u306f\u30c1\u30e3\u30c3\u30c8\u30dc\u30c3\u30c8\u3067\u306f\u3042\u308a\u307e\u305b\u3093 \u2014 \u30c8\u30d4\u30c3\u30af\u3092\u5165\u529b\u3059\u308b\u3068\u3001\u52d5\u753b\u30ec\u30c3\u30b9\u30f3\u3092\u751f\u6210\u3057\u307e\u3059\uff01",
  onboarding_step2: "PDF\u3084\u5199\u771f\u3092\u30c9\u30ed\u30c3\u30d7\u3059\u308b\u3068\u3001\u5404\u554f\u984c\u3092\u30b9\u30c6\u30c3\u30d7\u30d0\u30a4\u30b9\u30c6\u30c3\u30d7\u306e\u52d5\u753b\u89e3\u8aac\u306b\u5909\u63db\u3057\u307e\u3059",
  onboarding_step3: "\u30b9\u30bf\u30fc\u30c8\u3092\u62bc\u3059\u3068\u52d5\u753b\u304c\u30ad\u30e5\u30fc\u306b\u5165\u308a\u307e\u3059\u3002\u30ec\u30f3\u30c0\u30ea\u30f3\u30b0\u4e2d\u3082\u81ea\u7531\u306b\u95b2\u89a7\u3067\u304d\u307e\u3059\uff01",
  onboarding_generating: "これは、数分間で得られるレッスンです。必要に応じて閲覧を続けてください。準備ができたらここに着陸します。",
  onboarding_skip: "\u30b9\u30ad\u30c3\u30d7",
  onboarding_next: "\u6b21\u3078",
  onboarding_done: "\u308f\u304b\u308a\u307e\u3057\u305f\uff01",
  // Generating Cards Row
  generating_label: "\u751f\u6210\u4e2d",
  // Lecture Session (Self Study)
  lecture_loading: "\u8aad\u307f\u8fbc\u307f\u4e2d...",
  lecture_fallback_title: "\u8b1b\u7fa9",
  lecture_building: "\u52d5\u753b\u3092\u4f5c\u6210\u4e2d...",
  lecture_building_time: "\u901a\u5e38 2\u301c4 \u5206\u304b\u304b\u308a\u307e\u3059",
  lecture_failed: "\u52d5\u753b\u306e\u751f\u6210\u306b\u5931\u6557\u3057\u307e\u3057\u305f",
  lecture_no_video: "\u307e\u3060\u52d5\u753b\u306f\u3042\u308a\u307e\u305b\u3093",
  lecture_followup: "\u30d5\u30a9\u30ed\u30fc\u30a2\u30c3\u30d7",
  lecture_now_playing: "\u518d\u751f\u4e2d",
  lecture_tab_videos: "\u52d5\u753b",
  lecture_tab_chat: "\u30c1\u30e3\u30c3\u30c8",
  lecture_chat_empty: "\u3053\u306e\u30c8\u30d4\u30c3\u30af\u306b\u3064\u3044\u3066\u4f55\u3067\u3082\u8cea\u554f\u3057\u3066\u304f\u3060\u3055\u3044",
  lecture_chat_chip1: "\u7c21\u5358\u306b\u8aac\u660e",
  lecture_chat_chip2: "\u4f8b\u3092\u51fa\u3057\u3066",
  lecture_chat_chip3: "\u306a\u305c\u5f79\u306b\u7acb\u3064\uff1f",
  lecture_chat_placeholder: "\u3053\u306e\u30c8\u30d4\u30c3\u30af\u306b\u3064\u3044\u3066\u8cea\u554f...",
  lecture_followup_placeholder: "\u30d5\u30a9\u30ed\u30fc\u30a2\u30c3\u30d7\u52d5\u753b\u3092\u8ffd\u52a0...",
  lecture_chat_error: "\u51e6\u7406\u3067\u304d\u307e\u305b\u3093\u3067\u3057\u305f\u3002\u3082\u3046\u4e00\u5ea6\u304a\u8a66\u3057\u304f\u3060\u3055\u3044\u3002",
  lecture_chat_generic_error: "\u554f\u984c\u304c\u767a\u751f\u3057\u307e\u3057\u305f\u3002\u3082\u3046\u4e00\u5ea6\u304a\u8a66\u3057\u304f\u3060\u3055\u3044\u3002",
  // Home shortcuts — square cards that jump to the Workspace composer preset to a mode
  home_sc_hw_title: "宿題PDF",
  home_sc_hw_desc: "問題セットをアップロードし、すべての質問について取り組んだビデオを入手します",
  home_sc_lecture_title: "講義PDF",
  home_sc_lecture_desc: "スライドやメモを一連のレッスンに変える",
  home_sc_course_title: "コースを作成する",
  home_sc_course_desc: "1 つのトピックに関する一連のレッスンを計画する",
  // Misc
  generic_error: "\u554f\u984c\u304c\u767a\u751f\u3057\u307e\u3057\u305f\u3002\u3082\u3046\u4e00\u5ea6\u304a\u8a66\u3057\u304f\u3060\u3055\u3044\u3002",
  loading: "\u8aad\u307f\u8fbc\u307f\u4e2d...",
};

export default ja;
